import { differenceInMinutes, format, formatDistanceStrict, isValid, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

/** Fecha ISO de la API → texto en la zona del navegador. Nunca `new Date(texto)`. */
export function fecha(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = parseISO(iso);
  return isValid(d) ? format(d, 'dd/MM/yyyy HH:mm') : iso;
}

/** «hace 3 min» respecto a `ahora`. */
export function haceCuanto(iso: string | null | undefined, ahora: Date = new Date()): string {
  if (!iso) return '—';
  const d = parseISO(iso);
  if (!isValid(d)) return iso;
  return `hace ${formatDistanceStrict(d, ahora, { locale: es, roundingMethod: 'floor' })}`;
}

export function minutosDesde(iso: string | null | undefined, ahora: Date = new Date()): number | null {
  if (!iso) return null;
  const d = parseISO(iso);
  return isValid(d) ? differenceInMinutes(ahora, d) : null;
}

/** 15 → «15 min», 240 → «4 h», 1440 → «1 d», 90 → «1 h 30 min». */
export function duracion(min: number | null | undefined): string {
  if (min === null || min === undefined) return '—';
  if (min % 1440 === 0) return `${min / 1440} d`;
  if (min >= 60) return min % 60 === 0 ? `${min / 60} h` : `${Math.floor(min / 60)} h ${min % 60} min`;
  return `${min} min`;
}

export function ventana(ini: number | null, fin: number | null): string {
  if (ini === null || fin === null) return 'siempre';
  const dos = (h: number) => String(h).padStart(2, '0');
  return `${dos(ini)}:00–${dos(fin)}:00`;
}

export function numero(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === '') return '—';
  const v = typeof n === 'string' ? Number(n) : n;
  return Number.isFinite(v) ? v.toLocaleString('es-ES') : String(n);
}

export function autor(a: { email: string | null; nombre: string | null; sub: string }): string {
  return a.nombre ?? a.email ?? a.sub;
}
